export default __webpack_public_path__ + "static/media/announcement_1.4e925e38.png";